const URL = '/owners/card_payment/';
export const SERVICES = {
  //DynamiCore
  DYNAMICORE_SERVICE: `${URL}dynamic-core`,

  // Companies
  COMMERCE: `${URL}company/commerce`,
  COMMERCE_INFO: `${URL}company/commerce_info`,
  GET_PROCESS: `${URL}thirds/service_config`,
  COMPANIES: `${URL}admin/companies`,
  COMPANY: `${URL}company`,
  COMPANY_NEW: `${URL}company/new`,
  COMPANY_NEW_V2: `${URL}company/v2/new`,
  NEW_COMMERCE: `${URL}company/v2/manageCommerce`,
  SEARCH_COMMERCE: `${URL}company/search-commerce`,
  COMMERCE_CASHBACK_CONFIG: `${URL}company/cashback_config`,
  COMPANY_UPDATE_PROPERTIES: `${URL}company/update_properties`,

  // Terminals
  GET_TERMINALS: `${URL}tools/terminal`,
  NEW_TERMINAL: `${URL}terminal/new_v2`,
  REASSIGN_TERMINAL: `${URL}terminal/manage`,
  SEARCH_TERMINAL: `${URL}tools/search-terminal`,
  // Terminales de un comercio INCLUYENDO su árbol (sucursales y sus hijas), con
  // filtro por config: ?commerce=3421&filter={"POS.active":true}. A diferencia
  // de GET_TERMINALS, el recorrido del árbol lo hace el backend.
  COMMERCE_TERMINALS: `${URL}tools/commerce_terminals`,
  TERMINAL_MODELS: `${URL}tools/terminal_model`,
  CONFIG_TEMPLATE: `${URL}tools/config_templates`,
  TERMINAL_CONFIG: `${URL}tools/terminal_config`,
  // Empuja un `extras` a varias terminales de un golpe.
  PUSH_TERMINAL_CONFIG: `${URL}tools/push_terminal_config`,
  // Sender XMPP → TPV: notificaciones, comandos y estado. `TERMINAL_XMPP_STATUS`
  // se consume por POST con `{sn}` en el body (sin prefijo GET_ porque el
  // endpoint es POST).
  SEND_TERMINAL_NOTIFICATION: `${URL}xmpp/notify`,
  SEND_TERMINAL_COMMAND: `${URL}xmpp/command`,
  TERMINAL_XMPP_STATUS: `${URL}xmpp/status`,
  // Alta de la cuenta XMPP de la terminal en Openfire. Es idempotente: si ya
  // existía responde 200 igual, así que reintentar no rompe nada.
  REGISTER_TERMINAL_XMPP: `${URL}xmpp/register`,

  PRODUCTS: `${URL}products`,

  // Punto de venta (POS). Los productos se registran directo en el comercio
  // (un solo paso) y se agrupan con `pos/groups`. `pos/main_products` trae de
  // una sola llamada los productos de todos los comercios de la compañía, para
  // resolver nombres e imágenes en ventas y transacciones.
  POS_PRODUCTS: `${URL}pos/products`,
  POS_GROUPS: `${URL}pos/groups`,
  POS_MAIN_PRODUCTS: `${URL}pos/main_products`,
  // Métricas de ventas del POS. Es una consulta, pero el endpoint se consume
  // como POST (los filtros van en el cuerpo).
  POS_PRODUCTS_DASHBOARD: `${URL}pos/products_dashboard`,

  //Reports
  REPORTS_GENERATE: `${URL}generated-reports`,
  REPORTS_CREATE: `${URL}reports/create`,
  REPORTS_GENERATE_HIDE: `${URL}generated-report/hide`,
  REPORTS_STATICS: `${URL}static-reports`,
  REPORT_SIGNIN_DOCUMENT: `${URL}/reports/sign-documents`,

  // Transactions
  TRANSACTIONS: `${URL}transactions`,
  TRANSACTIONS_FILTERS: `${URL}txn/search_filter`,
  TRANSACTION_DOWNLOAD: `${URL}transactions/generate-receipt`,
  TRANSACTION_CANCEL: `${URL}transactions/cancel`,
  TRANSACTION_REFUND: `${URL}transactions/refund`,
  TRANSACTION_REVERSE: `${URL}transactions/reverse`,

  // Users
  USERS: `${URL}users_details`,
  USERS_ADD: `${URL}users/add`,
  USERS_ADD_V2: `${URL}users/v2/add`,
  USERS_GET_INFO: `${URL}users/get_info`,
  USERS_PRESIGNIN_DOCUMENT: '/users/presignin_documents',
  USERS_ROLES_TEMPLATE: `${URL}users/rolestemplate`,
  USERS_ROLES_TEMPLATE_WRITE: `${URL}users/rolestemplate`,
  CATALOGS_ROLES: `${URL}catalog/roles_admin`,
  USERS_ROLES: `${URL}users/roles`,

  // Liquidation reports (ms-card-payment · tools/liquidation_report)
  LIQUIDATION_REPORT: `${URL}tools/liquidation_report`,

  // Taxonomy
  TAXONOMY: `${URL}taxonomy`,

  // Services
  SERVICES: `${URL}integrations/services`,
};

export const CONF = {
  // main_products recibe `id` como la compañía a consultar, no como búsqueda
  // por id: sin esto processResponse devolvería el objeto interno
  [SERVICES.POS_MAIN_PRODUCTS]: {
    getById: false,
  },
};
